export default ({ spacing }) => ({
  chip: {
    margin: [spacing.unit / 2, spacing.unit, spacing.unit / 2, 0],
  },
});
